import * as React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

// @ts-ignore
import QuickPromotionActions from 'actions/QuickPromotionActions';
import ConfirmDialog from 'components/ConfirmDialog';
// @ts-ignore
import { ImageTypes, PromotionTypes, ResponseTypes } from 'constants/QuickPromotionConstants';
import QuickPromotion from 'entities/QuickPromotion';
// @ts-ignore
import SisMergeExistingAccountsModal from 'organizations/components/SisMergeExistingAccountsModal';
// @ts-ignore
import SisMergeExistingStudentModal from 'organizations/components/SisMergeExistingStudentModal';
// @ts-ignore
import SisMergeExistingTeacherModal from 'organizations/components/SisMergeExistingTeacherModal';

import './styles/QuickPromotionModal.scss';

type Props = {
  triggeredContext: string;
  promotion: QuickPromotion;
  onConfirm: (promotion: QuickPromotion) => void;
  onCancel: (promotion: QuickPromotion) => void;
  onRequestHide: () => void;
};

class QuickPromotionModal extends React.Component<Props> {
  static childContextTypes = {
    eventScreenName: PropTypes.string,
    eventProperties: PropTypes.object,
  };

  getChildContext() {
    return {
      eventScreenName: 'QuickPromotionModal',
      eventProperties: { ui_context: this.props.triggeredContext },
    };
  }

  handleConfirm = () => {
    this.props.onRequestHide();
    this.props.onConfirm(this.props.promotion);
  };
  handleCancel = () => {
    this.props.onRequestHide();
    this.props.onCancel(this.props.promotion);
  };
  renderCustom = () => {
    const { promotion } = this.props;

    const dismissPrompt = () => {
      QuickPromotionActions.recordDismissal(promotion, ResponseTypes.DISMISSED);
      this.props.onRequestHide();
    };

    switch (promotion.getPromotion()) {
      case 'sis_merge_existing_student':
        return (
          <SisMergeExistingStudentModal
            onConfirm={this.handleConfirm}
            promotion={promotion}
            onRequestHide={this.props.onRequestHide}
            onDialogDismiss={dismissPrompt}
          />
        );
      case 'sis_merge_existing_teacher':
        return (
          <SisMergeExistingTeacherModal
            onConfirm={this.handleConfirm}
            promotion={promotion}
            onRequestHide={this.props.onRequestHide}
            onDialogDismiss={dismissPrompt}
          />
        );
      case 'sis_merge_existing_accounts':
        return (
          <SisMergeExistingAccountsModal
            onConfirm={this.handleConfirm}
            onCancel={this.handleCancel}
            promotion={promotion}
            onRequestHide={() => {}}
          />
        );
      default:
        console.error('Unexpected custom quick promotion: ' + promotion.getPromotion());
        return null;
    }
  };
  render() {
    const { promotion } = this.props;

    if (promotion.getType() === PromotionTypes.CUSTOM) {
      return this.renderCustom();
    }

    let secondaryButton = false;
    let secondaryButtonText = '';
    const secondaryAction = promotion.getSecondaryAction();

    if (secondaryAction) {
      secondaryButton = true;
      secondaryButtonText = secondaryAction.getLabel();
    }

    return (
      <ConfirmDialog
        eventScreenName="QuickPromotionModal"
        className={cx('QuickPromotionModal', {
          'with-banner': promotion.getImageType() === ImageTypes.BANNER,
        })}
        size="xsmall"
        hideCloseButton={!promotion.isDismissable()}
        hideOnBlur={false}
        title={promotion.getHeader()}
        subtext={promotion.getBody()}
        image={promotion.getImageUrl()}
        actionButtonText={promotion.getPrimaryAction().getLabel()}
        hideCancel={!secondaryButton}
        cancelButtonText={secondaryButtonText}
        imageSize="large"
        onConfirm={this.handleConfirm}
        onCancel={this.handleCancel}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}

export default QuickPromotionModal;
